// extracted by mini-css-extract-plugin
export default {"registerPage":"Register_registerPage__vseH4"};